const useragent = require('express-useragent')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {object} context
 * @param {string} context.userId
 * @param {string} context.userIp
 * @param {string} context.userAgent
 * @param {string} context.route.path
 * @returns {{userIp: ({userId}|*|string), userId: (*|Object|string), url: *}}
 */
function getUserAttributes (context) {
  const userId = context?.userId
  const userIp = context?.userIp
  const userAttributes = context?.userAgent
    ? useragent.parse(context?.userAgent)
    : {}

  const browserVersion = parseInt(userAttributes?.version)
    ? parseInt(userAttributes?.version)
    : userAttributes?.version

  userAttributes.url = context?.route?.path
  userAttributes.browserAndVersion = `${userAttributes?.browser}-${browserVersion}`

  return {
    ...userAttributes,
    userId,
    userIp
  }
}

module.exports = { getUserAttributes }
